import { push } from 'react-router-redux';

import { ApiService } from 'services';
import { redirectToLogin } from 'actions/auth';
import { handleException } from 'actions/exceptions';

export const CONFIRM_AUTHENTALINK_REQUEST = 'CONFIRM_AUTHENTALINK_REQUEST';
export const CONFIRM_AUTHENTALINK_SUCCESS = 'CONFIRM_AUTHENTALINK_SUCCESS';
export const CONFIRM_AUTHENTALINK_FAILURE = 'CONFIRM_AUTHENTALINK_FAILURE';
export const CLEAR_AUTHENTALINK_FAILURE = 'CLEAR_AUTHENTALINK_FAILURE';
export const CONFIRM_AUTHENTALINK_PIN_FAILURE = 'CONFIRM_AUTHENTALINK_PIN_FAILURE';

function reset() {
  return {
    type: CLEAR_AUTHENTALINK_FAILURE
  };
}

function request(email) {
  return {
    type: CONFIRM_AUTHENTALINK_REQUEST,
    authenticatingEmail: email
  };
}

function receive(data) {
  return {
    type: CONFIRM_AUTHENTALINK_SUCCESS,
    resendReference: data.resendReference
  };
}

function reject(error) {
  return {
    type: CONFIRM_AUTHENTALINK_FAILURE,
    code: error.code,
    message: error.message
  };
}

function rejectPin(error) {
  return {
    type: CONFIRM_AUTHENTALINK_PIN_FAILURE,
    code: error.code,
    message: error.message
  };
}

export function confirmAuthentaLink(email, uniqueRef, name, uniqueRefOnly, pin) {
  const postData = {
    email,
    uniqueRef,
    name,
    uniqueRefOnly,
    pin
  };

  return (dispatch) => {
    dispatch(request(email));

    const promise = () => ApiService
      .postAuthentaLink(postData)
      .then((response) => {
        if (response.data && response.data.data && response.data.success) {
          dispatch(receive(response.data.data));
          if (response.data.data.navigateToPath !== null) {
            return dispatch(push(response.data.data.navigateToPath));
          }

          if (response.data.data.loginSuccess) {
            return dispatch(redirectToLogin());
          }

          return dispatch(push('/'));
        }

        if (response.data && response.data.error) {
          return dispatch(reject(response.data.error));
        }

        return dispatch(reject({
          code: '-9999',
          message: 'Sorry, there was an unexpected error communicating with our servers'
        }));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch({ type: CONFIRM_AUTHENTALINK_FAILURE });
          dispatch(handleException(error, reject));
        }
      });

    return promise();
  };
}

export function verifyCustomerAndPin(id, pin) {
  const postData = {
    id,
    pin,
  };
  return (dispatch) => {
    const promise = () => ApiService
      .postAuthentaLink(postData)
      .then((response) => {
        if (response.data && response.data.data && response.data.success) {
          dispatch(receive(response.data.data));
          if (response.data.data.navigateToPath !== null) {
            return dispatch(push(response.data.data.navigateToPath));
          }

          if (response.data.data.loginSuccess) {
            return dispatch(redirectToLogin());
          }

          return dispatch(push('/'));
        }

        if (response && response.data.error) {
          return dispatch(rejectPin(response.data.error));
        }

        return dispatch(rejectPin({
          code: '-9999',
          message: 'Sorry, there was an unexpected error communicating with our servers'
        }));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch({ type: CONFIRM_AUTHENTALINK_FAILURE });
          dispatch(handleException(error, reject));
        }
      });

    return promise();
  };
}

export function clearAuthentaLinkError() {
  return dispatch => dispatch(reset());
}
